export default __webpack_public_path__ + "static/media/backer-web.e85d89a8.webp";